import { Injectable } from '@angular/core';
import { ResourceEffect } from '@app/core/store/effects/resource.effect';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';
import {
  LoadMIPSCommentsSuccessAction,
  LoadMIPSCommentsAction,
  LoadCommentCountAction,
  LoadCommentCountSuccessAction,
  CommentsActionTypes,
} from '@dwo/actions';
import { State } from '@dwo/reducers';
import { CommentsService } from '@app/core/services/comments.service';

@Injectable()
export class CommentsEffect extends ResourceEffect {
  constructor(
    readonly actions$: Actions,
    readonly commentsService: CommentsService,
    readonly store: Store<State>,
  ) {
    super(actions$, commentsService, store);
  }

  loadMIPSComments$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<LoadMIPSCommentsAction>(CommentsActionTypes.LoadMIPSComments),
        this.fetchResource('loadMIPSComments', LoadMIPSCommentsSuccessAction, (action: LoadMIPSCommentsAction) => [
          action.workOrderId,
        ]),
      ),
  );

  loadCommentCount$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<LoadCommentCountAction>(CommentsActionTypes.LoadCommentCount),
        mergeMap((action) =>
          this.commentsService
            .getCommentsCount(action.workOrderId)
            .pipe(
              map(
                (counts) =>
                  new LoadCommentCountSuccessAction(
                    action.workOrderId,
                    counts.comments,
                    counts.materialComments,
                    counts.workLineComments,
                  ),
              ),
            ),
        ),
      ),
  );
}
